import React, {FC, useEffect, useState} from 'react'
import {PageTitle} from '../../../../_metronic/layout/core'
import {BreadCrumbs} from '../../../components/BreadCrumbs/breadCrumbrs'
import {Button} from '../../../components/Button/Button'
import {Input} from '../../../components/Input/Input'
import {Loading} from '../../../components/Loading/Loading'
import {GET, PUT} from '../../../services/api'
import Swal from 'sweetalert2'
import {useNavigate, useParams} from 'react-router-dom'

const ReviewHotelCategoryEditForm: FC = () => {
  const navigate = useNavigate()
  const {id} = useParams<{id: string}>()
  const [loading, setLoading] = useState(false)
  const [saving, setSaving] = useState(false)

  // Campos do formulário
  const [title, setTitle] = useState('')
  const [order, setOrder] = useState('0')

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        const res = await GET(`/review-hotel-category/${id}`)
        const categoryData = res?.data || res?.dados || res

        if (!categoryData?.id) {
          throw new Error('Categoria não encontrada.')
        }

        setTitle(categoryData.title || '')
        setOrder(String(categoryData.order ?? 0))
      } catch (error: any) {
        console.error('Erro ao carregar dados:', error)
        Swal.fire({
          icon: 'error',
          title: 'Erro ao carregar',
          text: error?.message || 'Não foi possível carregar os dados.',
        }).then(() => navigate('/hospitality/feed-back/category'))
      } finally {
        setLoading(false)
      }
    }

    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  const handleSave = async () => {
    try {
      setSaving(true)
      setLoading(true)

      if (!title.trim()) {
        throw new Error('Informe o título da categoria.')
      }

      const payload = {
        title: title.trim(),
        order: Number(order) || 0,
      }

      const res = await PUT(`/review-hotel-category/${id}`, payload)

      if (res?.success) {
        await Swal.fire({
          icon: 'success',
          title: 'Atualizada com sucesso',
          text: 'A categoria foi salva.',
        })
        navigate('/hospitality/feed-back/category')
      } else {
        throw new Error(res?.message || 'Não foi possível atualizar a categoria.')
      }
    } catch (error: any) {
      console.log(error)
      Swal.fire({
        icon: 'error',
        title: 'Erro ao atualizar',
        text: error?.message || 'Não foi possível atualizar a categoria.',
      })
    } finally {
      setSaving(false)
      setLoading(false)
    }
  }

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>Editar Categoria</span>
                <BreadCrumbs />
                <span className='text-muted mt-1 fw-bold fs-7'>
                  Altere as informações da categoria de formulários.
                </span>
              </h3>
            </div>

            <div className='card-body'>
              <div className='row g-5 align-items-end'>
                <div className='col-md-6'>
                  <Input
                    label='Título'
                    inputAttr={{type: 'default'}}
                    value={title}
                    change={(value: string) => setTitle(value)}
                    placeholder='Ex: Quartos, Restaurante, Recepção...'
                    maxCaracteres={50}
                    required
                  />
                </div>

                <div className='col-md-6'>
                  <Input
                    label='Ordem'
                    inputAttr={{type: 'number'}}
                    value={order}
                    change={(value: string) => setOrder(value)}
                    placeholder='0'
                    marginTop='0'
                  />
                </div>
              </div>
            </div>

            <div className='card-footer d-flex justify-content-end gap-3 py-6'>
              <Button
                text='Voltar'
                color='info'
                size='small'
                click={() => navigate('/hospitality/feed-back/category')}
                btnClass='fw-bolder hover-scale'
              />
              <Button
                text='Salvar'
                color='primary'
                size='small'
                click={handleSave}
                loading={saving}
                btnClass='fw-bolder hover-scale'
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const ReviewHotelCategoryEdit: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: true},
          {title: 'Categorias', path: '/hospitality/feed-back/category', isActive: true},
          {title: 'Editar', path: '#', isActive: true},
        ]}
      >
        Editar Categoria
      </PageTitle>
      <ReviewHotelCategoryEditForm />
    </>
  )
}

export {ReviewHotelCategoryEdit}
